import { render, staticRenderFns } from "./marketing-seller.vue?vue&type=template&id=38181620&"
import script from "./marketing-seller.vue?vue&type=script&lang=js&"
export * from "./marketing-seller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports